<template>
  <div id="exam_detail" v-if="examDetail.examInfo">
     <el-form ref="form" class="flex column">
      <div class="exam-title flex bCenter middle result">
        <p><span>成绩：{{ examDetail.examScore }}分</span>（{{ examDetail.examInfo.passScore }}分及格）</p>
        <div>
          <el-button type="primary" plain size="small" @click="$router.go(-1)">返回</el-button>
        </div>
      </div>
      <div class="objective" v-if="objectiveTotal">
        <div class="exam-title flex bCenter middle">
          <p>客观题（共{{ objectiveTotal }}题，{{ examDetail.examInfo.objectiveQuesList | totalScore }}分）</p>
          <div>正确{{ totalRight }}题，错误{{ objectiveTotal - totalRight }}题</div>
        </div>
        <ul class="questions">
          <li v-for="(item,index) in examDetail.examInfo.objectiveQuesList" :key="index">
            <p class="questions-title flex bCenter">
              <span class="title-left">
                {{ index+1 }}、（{{ isMultipleSelection(item.subjectOptions).type }}）{{ item.name }}
              </span>
              <span
                class="title-right-correct"
                :class="{'wrong':!comparedResult.errorList[index]}">
                  {{ comparedResult.errorList[index]?'正确':'错误' }}
              </span>
            </p>
            <!-- 单选 -->
            <el-form-item v-if="!isMultipleSelection(item.subjectOptions).bol">
              <el-radio-group
                class="flex column"
                v-model="resultList[index]"
                >
                <el-radio
                  v-for="(citem,cindex) in item.subjectOptions"
                  :key="cindex"
                  :label="citem.id">
                    {{ citem.name }}
                  </el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 多选 -->
            <el-form-item v-else>
              <el-checkbox-group
                v-if="checkBoxGroup[index]"
                v-model="checkBoxGroup[index]"
                class="flex column"
                >
                <el-checkbox
                  v-for="(citem,cindex) in item.subjectOptions"
                  :key="cindex"
                  :label="citem.id">
                  {{ citem.name }}
                </el-checkbox>
              </el-checkbox-group>
              <!-- 解决未作答无试题bug -->
              <el-checkbox-group
                v-else
                class="flex column"
                v-model="checkBoxGroup"
                >
                <el-checkbox
                  :checked="citem.isChecked"
                  v-for="(citem,cindex) in item.subjectOptions"
                  :key="cindex"
                  :label="citem.id">
                  {{ citem.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </li>
        </ul>
      </div>
      <!-- 主观题 -->
      <div class="subjective" v-if="subjectiveTotal">
        <div class="exam-title flex bCenter middle">
          <p>主观题（共{{ subjectiveTotal }}题，{{ examDetail.examInfo.subjectiveQuesList | totalScore }}分）</p>
          <div>得分 {{ subjectiveScore }}</div>
        </div>
        <ul class="questions">
          <li v-for="(item,index) in examDetail.examInfo.subjectiveQuesList" :key="index">
            <p class="questions-title flex bCenter">
              <span class="title-left">
                {{ index+1 }}、（{{ item.score }}分）{{ item.name }}
              </span>
              <span
                v-if="redo[index]"
                class="title-right-correct"
                :class="{'wrong':redo[index]}">
                需重做
              </span>
            </p>
            <el-form-item>
              <div class="remark">
                <div>
                  <div class="answer">
                    答：{{ subjectiveAnswer[index] || '未作答' }}
                  </div>
                  <div class="answer" v-if="fileList[index]">
                    文件：<el-link target="_blank" :download="fileList[index].name"  type="primary" :underline="false" :href="fileList[index] | fileUrl">{{ fileList[index].name || '无' }}</el-link>
                  </div>
                  <div class="score">评分：{{ evaluate[index] || 0 }} 分</div>
                  <div class="comment">评语：{{ comments[index] || '无' }}</div>
                </div>
                <div v-if="answerRedoList[index]">
                  <ul v-if="answerRedoList[index].length" class="redoRecord">
                    重做历史：
                    <li
                      v-for="(item,index) in answerRedoList[index]"
                      :key="index">
                      {{ index+1 }}、
                      <div>答：{{ item.subjectiveAnswer }}</div>
                      <div v-if="item.attach[0]">文件：
                        <el-link target="_blank" :download="item.attach[0].name"  type="primary" :underline="false" :href="item.attach[0] | fileUrl">
                          {{ item.attach[0].name || '无' }}
                        </el-link>
                      </div>
                      <div>评分：{{ item.evaluate || 0 }} 分</div>
                      <div>评语：{{ item.comments || '无' }}</div>
                    </li>
                  </ul>
                </div>
                <el-form-item v-if="redo[index]">
                  <el-upload
                    v-if="item.isUpload"
                    class="upload-demo flex"
                    :action="fileUploadUrl"
                    :with-credentials="true"
                    :headers="myHeader"
                    :file-list="fileLists[index]"
                    :on-success="handleAvatarSuccess"

                    :on-remove="handleAvatarRemove"
                    name="hqfile"
                    :multiple="false"
                    :limit="1">
                    <el-button size="small" type="primary" style="margin-right:20px;" @click.native="getId(index)">上传文档</el-button>
                  </el-upload>
                  <el-input
                    v-if="item.isWord"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 5}"
                    placeholder="请输入内容"
                    maxlength="10000"
                    v-model="subjectiveRedo[index]">
                  </el-input>
                    <!-- @blur="handleChecked(item.id,subjectiveRedo[index],item.isUpload)" -->
                </el-form-item>
              </div>
            </el-form-item>
          </li>
        </ul>
        <div class="flex center" v-if="!$utils.isArrayEmpty(redoId)">
          <el-button size="small" type="primary" style="margin-top:20px;" @click="handleSubmiteRedo()">提交答案</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { submitRedoSubjectAnswer, submitExamPaper } from '@/service/api/methods/educationCloud';
export default {
  data(){
    return{
      examDetail:this.$utils.getExamDetail(),
      //单选题答案组
      comparedResult : {
        //错误题目组
        errorList : [],
        //答对题目数
        correntNumber : 0,
      },
      //上传的文档
      fileUploadUrl: this.$constant.clooudFileUploadUrl, //上传文档地址
      myHeader: {//上传图片带token
        Authorization: this.$store.state.user.userInfo.token
      },
      //多选题答案组
      checkBoxGroup:[],
      //单选题目答案组
      resultList:[],
      //主观题答案组
      subjectiveAnswer:[],
      fileList:[],
      comments:[],
      evaluate:[],
      redo:[],
      answerRedoList:[],
      subjectiveRedo:[],
      fileLists:[],
      fileListRedo:[],
      redoId:[],
      answer:[],
      fileId:0,
      evaluateCoye:[],
    }
  },
  filters:{
    totalScore(value){
      let total = 0;
      value.map((item)=>{
        total += Number(item.score);
      })
      return total;
    },
    fileUrl(value){
      return sessionStorage.getItem('baseUrl') + value.filePath+value.ext
    }
  },
  computed:{
    totalRight(){
      let i = 0;
      this.comparedResult.errorList.map((item)=>{
        if(item){
          i ++;
        }
      })
      return i
    },
    objectiveTotal(){
      return this.examDetail.examInfo.objectiveQuesList? this.examDetail.examInfo.objectiveQuesList.length:0;
    },
    subjectiveTotal(){
      return this.examDetail.examInfo.subjectiveQuesList? this.examDetail.examInfo.subjectiveQuesList.length:0;
    },
    subjectiveScore(){
      let total = 0;
      this.evaluateCoye.map((item)=>{
        total += Number(item)
      })
      return total;
    }
  },
  created(){
    this.initResult()
  },
  methods:{
    //是否为多选题目
    isMultipleSelection(topic){
      let num = 0;
      topic.map((item)=>{
        if(item.isAnswer === 1){
          num ++
        }
      })
      return num >= 2? {bol :true,type:'多选'} : {bol :false,type:'单选'};
    },
    //对已做的题目答案进行初始化处理
    initResult(){
      this.compared();
      this.fileListRedo = [];

    },
    //对比正确答案
    compared(){
      this.comparedResult = {
        errorList : [],
        correntNumber : 0,
      }
      let answers  = this.examDetail.optionsAndAnswers;
      if(answers.length){
        //客观题
        this.examDetail.examInfo.objectiveQuesList.map((item,index)=>{
          let myOption = [] ;//放置正确答案

          answers.map((citem)=>{
            if(item.id == citem.subjectid){
              // 是答案
              item.subjectOptions.map((ditem,dindex)=>{
                if(ditem.isAnswer == 1){
                  myOption.push(ditem.id)
                  if(this.isMultipleSelection(item.subjectOptions).bol){//多选
                    this.checkBoxGroup[index] = citem.optionid.split(',')//回显答案
                    if(myOption.length == citem.optionid.split(',').length){
                      if(myOption.sort().toString() == citem.optionid.split(',').sort().toString()){
                        this.comparedResult.errorList[index] = true;
                      }
                    }else{
                      this.comparedResult.errorList[index] = false;
                    }
                  }else{//是单选
                    this.resultList[index] = citem.optionid;
                    if(ditem.id == citem.optionid){
                      this.comparedResult.errorList[index] = true;
                    }
                  }
                }
              })
            }
          })
        })
        //主观题
        this.examDetail.examInfo.subjectiveQuesList.map((item,index)=>{
          answers.map((citem)=>{
            if(item.id == citem.subjectid){
              this.fileList[index] = citem.attach[0]?citem.attach[0] :'';
              this.subjectiveAnswer[index] = citem.subjectiveAnswer;
              this.comments[index] = citem.comments;
              if(!this.$utils.isArrayEmpty(citem.answerRedoList)){
                this.evaluateCoye[index] = citem.answerRedoList[citem.answerRedoList.length-1].evaluate;
              }else{
                this.evaluateCoye[index] = citem.evaluate;
              }
              this.evaluate[index] = citem.evaluate;
              this.redo[index] = citem.redo;
              this.answerRedoList[index] = citem.answerRedoList;
              if(citem.redo == 1){
                this.redoId[index] = citem.id
                this.fileListRedo[index] = undefined
              }
            }
          })
        })
      }
    },
    //提交重做试卷
    handleSubmiteRedo(){
      if(!this.$utils.isArrayEmpty(this.redoId)){
        this.redoId.map((item,index)=>{
          let params = {
              attach:[],
            },
            arr=[];
          params.answerid = item;
          params.subjectiveAnswer = this.subjectiveRedo[index] || '';
          if(this.fileListRedo[index] != undefined){
            params.attach[0] = this.fileListRedo[index]
          }else{
            params.attach = []
          }
          this.answer[index] = params
        })
        for(let j in this.redo){
          if(this.redo[j] == 1){
            if(this.examDetail.examInfo.subjectiveQuesList[j].isUpload == 1){
              if(this.$utils.isArrayEmpty(this.answer[j].attach)){
                  // console.log(this.answer[j])
                  this.$message({
                    type:'warning',
                    message:'请先上传文件后再提交',
                    center:true,
                  })
                  return
                }
              }
          }
        }
      }
      let arr = [];
      this.answer.map((citem,cindex)=>{
        if(!(!citem && typeof(citem)!="undefined" && citem!=0) || citem){
          arr.push(citem)
        }
      })
      // this.submitRedo(arr)

    },

    //提交主观题重做答案
    submitRedo(params){
      submitRedoSubjectAnswer({answer : JSON.stringify(params)}).then(
        res=>{
          this.$message({
            type:'success',
            center:true,
            message:res.message
          })
          this.$router.go(-1)
        }
      )
    },
    // //主观题输入框
    // handleChecked(subjectid,optionid,isUpload){
    //   if(isUpload == 0){
    //     this.params.attach = [];
    //     delete this.params.attach;
    //   }
    //   this.params.subjectiveAnswer = optionid;
    //   for(let i in this.examDetail.optionsAndAnswers){
    //     if(this.examDetail.optionsAndAnswers[i].subjectid == subjectid){
    //       this.params.answerid = this.examDetail.optionsAndAnswers[i].id;
    //       this.submitRedo();
    //       return;
    //     }
    //   }
    // },
    // //点击上传文件按钮
    // handleUpload(subjectid,subjectiveAnswer){
    //   this.params.subjectiveAnswer = subjectiveAnswer;
    //   for(let i in this.examDetail.optionsAndAnswers){
    //     if(this.examDetail.optionsAndAnswers[i].subjectid == subjectid){
    //       this.params.answerid = this.examDetail.optionsAndAnswers[i].id;
    //       return
    //     }
    //   }
    // },
    getId(id){
      this.fileId = id;
    },
    //文件上传成功时的钩子
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
        let pointIndex = res.data.url.lastIndexOf('.');
        let obj = {
          name:file.name,
          filePath:res.data.url.slice(0,pointIndex),
          ext:/\.[^\.]+$/.exec(res.data.url)[0],
          uid:file.uid
        };
        this.fileListRedo[this.fileId] = obj;
        this.$message.success(res.message);
      }else {
        this.$message.error(res.message);
      }
    },
    //文件列表移除文件时的钩子
    handleAvatarRemove(file, fileList){
      this.fileListRedo.map((item,index)=>{
        if(item){
          if(item.uid == file.uid){
            this.fileListRedo.splice(index,1,undefined)
          }
        }
      })
    }

  }
}
</script>
<style lang="less" scoped>
@import './ExamDetail.less';
</style>

